module.exports = __webpack_public_path__ + "img/omotenashiselection-header2.ec8c2964.jpg";